import { render, staticRenderFns } from "./ChangeAmountStatus.vue?vue&type=template&id=71cc6bbe&scoped=true&"
import script from "./ChangeAmountStatus.vue?vue&type=script&lang=js&"
export * from "./ChangeAmountStatus.vue?vue&type=script&lang=js&"
import style0 from "./ChangeAmountStatus.vue?vue&type=style&index=0&id=71cc6bbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cc6bbe",
  null
  
)

export default component.exports